// extracted by mini-css-extract-plugin
export default {"root":"Question_root__BAe2P","body":"Question_body__jfRlb","disabled":"Question_disabled__TcwZU"};